// extracted by mini-css-extract-plugin
module.exports = {"opacity":"zys12WmIAlIUGFy6J3WqD","loading":"_3h-ThfRkAK-TarJrwp7RV7","originators":"_2W1xbtCiG8Za1vjeMK7QfL","transparentLogo":"c4uAy4-FeOMZ-E0qH1ai6"};